import { render, staticRenderFns } from "./RememberDevice.vue?vue&type=template&id=740f5c3d&"
import script from "./RememberDevice.vue?vue&type=script&lang=ts&"
export * from "./RememberDevice.vue?vue&type=script&lang=ts&"
import style0 from "./RememberDevice.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports